import React, { useContext, useMemo } from 'react';
import { createUseStyles, useTheme, Text, Divider, Link, Icon } from '@Sage/hoi-poi-ui';
import { FEATURES } from "../../../../lib/services/copilot";
import { CopilotChat } from "../..";
import { CopilotContext } from "../../Context";
import CopilotSidebarTabHeader from "../components/CopilotSidebarTabHeader";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotSidebarChat');
var _ref2 = /*#__PURE__*/React.createElement(CopilotSidebarTabHeader, {
  title: "Chat"
});
var _ref3 = /*#__PURE__*/React.createElement(Divider, null);
var _ref4 = /*#__PURE__*/React.createElement("span", null, "Check AI content for inaccuracies. This content is for information purposes and is not professional advice.");
var _ref5 = /*#__PURE__*/React.createElement(Link, {
  variation: "primary",
  type: "caption",
  target: "_blank",
  href: "https://www.forcemanager.com/wp-content/uploads/Current-Dana-Disclaimer.pdf"
}, "Privacy policy");
const CopilotSidebarChatTab = _ref => {
  let {
    locale
  } = _ref;
  const theme = useTheme();
  const classes = useStyles();
  const {
    activeAgent
  } = useContext(CopilotContext);
  const chatProps = useMemo(() => ({
    locale,
    className: classes.chat,
    session: {
      features: [(activeAgent === null || activeAgent === void 0 ? void 0 : activeAgent.name) || FEATURES.SAGE_COPILOT]
    },
    defaultFirstInteraction: 'Hello, how can I help you today?'
  }), [activeAgent === null || activeAgent === void 0 ? void 0 : activeAgent.name, classes.chat, locale]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chatContainer
  }, _ref2, /*#__PURE__*/React.createElement(CopilotChat, chatProps)), _ref3, /*#__PURE__*/React.createElement("div", {
    className: classes.chatFooter
  }, /*#__PURE__*/React.createElement(Text, {
    type: "caption"
  }, _ref4, /*#__PURE__*/React.createElement("span", {
    className: classes.chatFooterLink
  }, _ref5, /*#__PURE__*/React.createElement(Icon, {
    name: "launch",
    color: theme.colors.actionMajor[500]
  })))));
};
export default CopilotSidebarChatTab;